var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.patentData.baseInfo.lawStatusList,"border":""}},[_c('el-table-column',{attrs:{"prop":"statusDate","label":"法律公告日"}}),_c('el-table-column',{attrs:{"prop":"label","label":"法律状态"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }